import type { ProductColor } from '@aloft/toolkit-shared';

import { OrderTag } from '../../OrderTable/types.ts';

export const getOrderTagTextColor = (tag: OrderTag): ProductColor => {
  switch (tag) {
    case OrderTag.Overdue:
      return 'textOffset';
    case OrderTag.Mock:
      return 'textOffset';
    case OrderTag.Escalated:
      return 'textOffset';
    default:
      return 'textPrimary';
  }
};
